import { makeServerRequest } from './util';
import moment from 'moment';

const apiPrefix = "/api/v1/branches";

export const fetchBranch = (branchId) => {
    return (dispatch) => {
        dispatch({type: "FETCH_BRANCH"});

        return makeServerRequest(apiPrefix + "/" + branchId).then(
            response => dispatch(fetchBranchSuccess(response.data))
        ).catch(
            error => dispatch(fetchBranchFailure(error))
        );
    };
};



export function fetchBranchSuccess(branch) {
    return {
        type: "FETCH_BRANCH_SUCCESS",
        payload: branch
    };
}


export function fetchBranchFailure(error) {
    return {
        type: "FETCH_BRANCH_FAILURE",
        payload: error
    };
}


export const fetchBranchTransactions = (branchId) => {
    return (dispatch) => {
        dispatch({type: "FETCH_BRANCH_TRANSACTIONS"});

        return makeServerRequest(apiPrefix + "/" + branchId + "/transactions?sort=txTime,desc").then(
            response => dispatch(fetchBranchTransactionsSuccess(response.data))
        ).catch(
            error => dispatch(fetchBranchTransactionsFailure(error))
        );
    };
};

export const fetchBranchTransactionsByDateRange = (branchId, startDate, endDate) => {
    return (dispatch) => {
        dispatch({type: "FETCH_BRANCH_TRANSACTIONS_BY_RATE_RANGE"});

        const startDateString = encodeURIComponent(moment(startDate).format("YYYY-MM-DD HH:mm:ss"));
        const endDateString   = encodeURIComponent(moment(endDate).format("YYYY-MM-DD HH:mm:ss"));

        return makeServerRequest(apiPrefix + "/" + branchId + "/transactions?sort=txTime,desc&startDate=" + startDateString + "&endDate=" + endDateString).then(
            response => dispatch(fetchBranchTransactionsSuccess(response.data))
        ).catch(
            error => dispatch(fetchBranchTransactionsFailure(error))
        );
    };
};


export function fetchBranchTransactionsSuccess(branch) {
    return {
        type: "FETCH_BRANCH_TRANSACTIONS_SUCCESS",
        payload: branch
    };
}


export function fetchBranchTransactionsFailure(error) {
    return {
        type: "FETCH_BRANCH_TRANSACTIONS_FAILURE",
        payload: error
    };
}




// WEBPACK FOOTER //
// ./src/store/actions/branch.js